import { createContext, useState } from "react";

export const ChargerContext = createContext(null);

export const ChargerProvider = ({ children }) => {
  const [chargerData, setChargerData] = useState(null);

  return (
    <ChargerContext.Provider value={{ chargerData, setChargerData }}>
      {children}
    </ChargerContext.Provider>
  );
};
